import { render, staticRenderFns } from "./courseNormal.vue?vue&type=template&id=d00f91b4&scoped=true"
import script from "./courseNormal.vue?vue&type=script&lang=js"
export * from "./courseNormal.vue?vue&type=script&lang=js"
import style0 from "./courseNormal.vue?vue&type=style&index=0&id=d00f91b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00f91b4",
  null
  
)

export default component.exports